"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppProtocolMeasurementEntries = getAppProtocolMeasurementEntries;
exports.transformAppProtocols = transformAppProtocols;
var _appProtocols = require("@kentik/ui-shared/dictionary/v2/compilers/appProtocols");
var _appProtocols2 = require("@kentik/ui-shared/dictionary/v2/processors/appProtocols");
function parseLookupValues(lookup) {
  if (!lookup) {
    return undefined;
  }
  const values = {};
  for (const [code, label] of Object.entries(lookup)) {
    const numCode = parseInt(code, 10);
    if (!Number.isNaN(numCode)) {
      values[numCode] = label;
    }
  }
  return Object.keys(values).length > 0 ? values : undefined;
}

/**
 * Transform raw app protocol data into MeasurementDimension and MeasurementMetric entries
 * that can be merged into the /traffic measurement's storage.
 */
function getAppProtocolMeasurementEntries(appProtocols) {
  const dimensions = {};
  const metrics = {};
  for (const protocol of appProtocols) {
    const category = protocol.display_name;
    for (const col of protocol.columns) {
      const {
        custom_column,
        dimension_direction,
        dimension_label,
        metadata: {
          is_metric = false,
          hll,
          metric_type = 'sum',
          is_bytes,
          is_count
        }
      } = col;
      const colKey = `ktappprotocol__${protocol.app_protocol}__${custom_column}`;
      const chfColumn = custom_column.toLowerCase();
      if (is_metric || hll) {
        // Skip HLL metrics — they need generic aggregate (agg0) handling that UDE doesn't support yet
        if (!hll) {
          const metricEntry = {
            Label: `${category}: ${dimension_label}`,
            Category: category,
            Column: chfColumn,
            Window: metric_type,
            ToBits: is_bytes || undefined,
            Rollup: true,
            Shared: true,
            ...(is_count && chfColumn === 'i_count' && metric_type === 'sum' && {
              Alias: 'trautocount'
            })
          };
          const metricValues = parseLookupValues(col.metadata.lookup);
          if (metricValues) {
            metricEntry.Values = metricValues;
          }
          metrics[colKey] = metricEntry;
        }
      }
      if (!is_metric) {
        const dim = {
          Label: dimension_label,
          Category: category,
          Column: chfColumn
        };
        if (dimension_direction === 'source') {
          dim.Direction = 'src';
          dim.Label = dimension_label.replace(/source\s/i, '');
        } else if (dimension_direction === 'destination') {
          dim.Direction = 'dst';
          dim.Label = dimension_label.replace(/destination\s/i, '');
        }
        const dimValues = parseLookupValues(col.metadata.lookup);
        if (dimValues) {
          dim.Values = dimValues;
        }
        dimensions[colKey] = dim;
      }
    }
  }
  return {
    dimensions,
    metrics
  };
}
function transformAppProtocols(raw) {
  if (!raw || raw.length === 0) {
    return null;
  }
  const filtered = (0, _appProtocols2.filterAppProtocols)({
    appProtocols: raw,
    permissions: false
  });
  const {
    dimensions,
    metrics
  } = getAppProtocolMeasurementEntries(filtered);
  const app_protocols = (0, _appProtocols.getAppProtocolsFromRaw)(filtered);
  return {
    dimensions,
    metrics,
    app_protocols
  };
}